<template>
    <!-- 过渡动画 -->
    <transition name="fade">
   　　 <div class="img-view" @click="bigImg">
   　　　　 <!-- 遮罩层 -->
   　　　　 <div class="img-view-layer"></div>
   　　　　 <div class="img-view-content" :style="getColor()" v-for="(imageSrc,key) in imageSrcs"  :key="key" @touchstart="touchstart" @touchend="touchend">
   　　　　　　 <img class="img-view-image" :src="imageSrc" mode="aspectFill">
   　　　　 </div>
    　　</div>
　　</transition>
</template>
<script>
export default {
    name:"imageViewer",
    props: {
        imageSrcs:{
            type:Array,
            default:function(){
                return [
                'https://resources.xycoder.com/dowa/CompanyIntroduction-3.jpeg',
                'https://resources.xycoder.com/dowa/CompanyIntroduction-3.jpeg',
                'https://resources.xycoder.com/dowa/dowa-logo-1.png',
                'https://resources.xycoder.com/dowa/dowa-logo-1.png'
                ]
            }
        },
        frame:{
            type:Object,
            default: function (){
                return {
                    'x':0,
                    'y':0,
                    'width':0,
                    'height':0,
                }
            }
        },

    },//接受图片地址
    data() {
        return {
            startX : 0,
			startY : 0,
			moveEndX : 0,
            moveEndY : 0
        }
    },
    mounted() {
    },
    methods: {
        getColor(){
            let r = parseInt(Math.random() * 256)
            let g = parseInt(Math.random() * 256)
            let b = parseInt(Math.random() * 256)
            return {backgroundColor:  `rgba(${r},${g},${b},1`}
        },
        bigImg(){
　　　　　　// 发送事件
            this.$emit('clickit')
        },
        scroll(){

        },
        touchstart(e){
            var _self = this;
            console.log(e.originalEvent)
            e.preventDefault();
            _self.startX = e.originalEvent.changedTouches[0].pageX;
            _self.startY = e.originalEvent.changedTouches[0].pageY;
        },
        touchend(e){
            var _self = this;
        }
　　　　}
　　}
</script>
<style scoped>

    .img-view{
        /* height: 100%; */
        position: fixed;
        height: 100vh;
        top: 0px;
        z-index: 1000;
        /* display: flex; */
        overflow-y:hidden;
        overflow-x: scroll;
        background: rebeccapurple;
        width: 100vw;
        white-space: nowrap;
    }
    /* chrome 和Safari */
    /* .img-view::-webkit-scrollbar { width: 0 !important } */
    /* IE 10+ */
    /* .img-view { -ms-overflow-style: none; } */
    /* Firefox */
    /* .img-view { overflow: -moz-scrollbars-none; } */
    .img-view-content{
        height: 100vh;
        width: 100vw;
        display: inline-block;
        justify-content: center;
        align-items: center;
        align-content: center;
    }
    .img-view-image{
        margin: 0 auto;
        /* height: 100vh; */
        max-width: 100vw;
        /* width: 100%; */
        max-height: 100vh;
        display: flex;
    }
    /* .fade-enter-active,
    .fade-leave-active {
        transition: all .2s linear;
        transform: translate3D(0, 0, 0)
    }
    .fade-enter,
    .fade-leave-active {
        transform: translate3D(100%, 0, 0)
    } */

/* 　　.img-view {
        position: absolute;
        width: 100%;
        height: 100%
　　}
　　.img-view .img-layer { 
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.7);
        width: 100%;
        height: 100%;
        overflow: hidden
　　}
    .img-view .img-view-content{
        position: absolute;
        height: 100%;
    }
　　.img-view .img-view-content .img-view-image {
        max-width: 100%;
        max-height: 100%;
        height: 100%;
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        z-index: 1000
　　} */
</style>


// WEBPACK FOOTER //
// src/components/ImageViewer/ImageViewer.vue